import Entity from '@/models/entities/Entity';

export class PreorderProduct implements Entity {
  public id: number = 0;
  public title: string = '';
  public enablePreorder: boolean = false;
  public minQuantity: number = 0;
  public minSizeQuantity: number = 0;

  constructor(initData: Partial<PreorderProduct>) {
    Object.assign(this, initData);
  }
}
